import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../features/auth/AuthContext';
import { SideNav, TopBar } from '@examflow/ui';
import { BeianFooter } from './BeianFooter';
import {
  layoutNavItems,
  layoutNavKeyToPath,
  resolveLayoutNavKey,
} from './layoutNav';
import { usePlatformSettings } from '../features/platform/PlatformSettingsContext';

function Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { settings } = usePlatformSettings();

  const isFocusMode = location.pathname.startsWith('/quiz');
  const activeKey = resolveLayoutNavKey(location.pathname);

  const handleNavigate = (key: string) => {
    const path = layoutNavKeyToPath[key];
    if (path) navigate(path);
  };

  const handleLogout = () => {
    logout();
  };

  // Focus mode: no sidebar; QuizPage owns full-viewport chrome + scroll.
  if (isFocusMode) {
    return (
      <div className="h-dvh overflow-hidden bg-surface-muted">
        <Outlet />
      </div>
    );
  }

  return (
    <div className="flex h-screen flex-col overflow-hidden bg-surface-muted">
      <TopBar
        brandName={settings.siteName || 'ExamFlow'}
        activeExam="TCF"
        entitlementLabel="进阶卡 · 78 天"
        language="中文"
        accountSlot={
          user ? (
            <div className="flex items-center gap-3">
              <span className="max-w-[120px] truncate text-sm text-ink-muted">
                {user.name || user.email?.split('@')[0]}
              </span>
              <button
                onClick={handleLogout}
                className="text-xs text-ink-muted transition-colors hover:text-ink-primary"
              >
                退出
              </button>
            </div>
          ) : null
        }
      />

      <div className="flex flex-1 overflow-hidden">
        <SideNav
          examTitle="考试空间"
          examTarget="TCF Canada · B2 · 2026年10月"
          items={layoutNavItems}
          activeKey={activeKey}
          onNavigate={handleNavigate}
        />

        <main className="flex flex-1 flex-col overflow-y-auto p-8">
          <div className="flex-1">
            <Outlet />
          </div>
          <BeianFooter className="mt-8 shrink-0 px-0 pb-0" siteName={settings.siteName} />
        </main>
      </div>
    </div>
  );
}

export default Layout;
